import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { TPreReservationFormValues } from '@app.feature/exam/gsat2024-2/constants/form'
import PredictionInputCheckbox from '@app.feature/exam/gsat2024-2/desktop/SectionThree/preReservation/preReservation.form/input/PredictionInputCheckbox.desktop'

const FormItemHasAgreedToPrivacy = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TPreReservationFormValues>()

  return (
    <StyledWrapper>
      <PredictionInputCheckbox
        buttonSize="small"
        buttonId="hasAgreedToPrivacy"
        label="개인정보 수집/이용 및 마케팅 수신 동의"
        {...register('hasAgreedToPrivacy')}
        isErrors={!!errors.hasAgreedToPrivacy}
      />
    </StyledWrapper>
  )
}

export default FormItemHasAgreedToPrivacy

const StyledWrapper = styled.div`
  width: 100%;
  margin-top: 24px;
`
